import DiversityPage from './DiversityPage';
export default DiversityPage;
